import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormPyramide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFormPyramide"><Path d="M1.5 16L12 2.5L22.5 16L12 21.5L1.5 16Z" stroke="currentColor"/><Path d="M12 3V21" stroke="currentColor"/></CentralIconBase>;
});

export default IconFormPyramide;
